<!--
 * @Author: lsh
 * @Date: 2021-03-02 10:53:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-23 15:27:06
 * @Descripttion: 
 * @FilePath: \scwater_development\src\views\projectOnly\investManage\components\planDialog.vue
-->
<template>
  <div class="wrap">
    <div class="total" v-if="tapDtData">
      <div class="item">
        <i></i>
        计划总投资：
        <b>{{
          (tapDtData.gsztz == 0 ? "0" : tapDtData.gsztz) ? tapDtData.gsztz : "-"
        }}</b>
        万元
      </div>
      <div class="item">
        <i></i>
        累计已完成：
        <b>{{
          (tapDtData.ljZtz == 0 ? "0" : tapDtData.ljZtz) ? tapDtData.ljZtz : "-"
        }}</b>
        万元
      </div>
      <div class="item">
        <i></i>
        未分配：
        <b>{{
          (tapDtData.wfpTz == 0 ? "0" : tapDtData.wfpTz) ? tapDtData.wfpTz : "-"
        }}</b>
        万元
      </div>
    </div>
    <div class="info">
      <span
        >{{ year }}年度共分配：<b>{{ totalMarks }}</b
        >万元</span
      >
      <el-button size="small" @click="reset()">重置</el-button>
    </div>
    <el-form status-icon :rules="rules" ref="ruleForm" label-width="0px">
      <table class="table-box">
        <thead style="background: #f4f4f4">
          <th style="width: 100px">月份</th>
          <th>中央投资(万元)</th>
          <th>省级投资(万元)</th>
          <th>地方投资(万元)</th>
          <th>其他(万元)</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in formData" :key="index">
            <td>
              <span>{{ item.planMonth }}月</span>
            </td>
            <td>
              <el-form-item prop="">
                <el-input
                  v-model="formData[index].zytz"
                  @input="valChange(formData[index].zytz, index, 'zytz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="">
                <el-input
                  v-model="formData[index].sjtz"
                  @input="valChange(formData[index].sjtz, index, 'sjtz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="">
                <el-input
                  v-model="formData[index].dftz"
                  @input="valChange(formData[index].dftz, index, 'dftz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="">
                <el-input
                  v-model="formData[index].qt"
                  @input="valChange(formData[index].qt, index, 'qt')"
                  autocomplete="off"
                  type="number"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div v-if="yearLength" class="year-wrap">
        <div v-for="(item, index) in formData" :key="index">
          <div class="tit" :class="'tit' + item.planMonth">
            {{ item.planMonth }}月
          </div>
          <div class="content" :class="'content' + item.planMonth">
            <div class="fill">
              <el-form-item label="中央投资：" prop="">
                <el-input
                  v-model="formData[index].zytz"
                  @input="valChange(formData[index].zytz, index, 'zytz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
                <div class="unit">万元</div>
              </el-form-item>
              <el-form-item label="省级投资：" prop="">
                <el-input
                  v-model="formData[index].sjtz"
                  @input="valChange(formData[index].sjtz, index, 'sjtz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
                <div class="unit">万元</div>
              </el-form-item>
              <el-form-item label="地方投资：" prop="">
                <el-input
                  v-model="formData[index].dftz"
                  @input="valChange(formData[index].dftz, index, 'dftz')"
                  autocomplete="off"
                  type="number"
                ></el-input>
                <div class="unit">万元</div>
              </el-form-item>
              <el-form-item label="其他：" prop="">
                <el-input
                  v-model="formData[index].qt"
                  @input="valChange(formData[index].qt, index, 'qt')"
                  autocomplete="off"
                  type="number"
                ></el-input>
                <div class="unit">万元</div>
              </el-form-item>
            </div>
          </div>
        </div>
      </div> -->
      <div class="footer_btn">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
        <el-button @click="goBack()">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { investPlanApi } from "@/api/projectOnly";

export default {
  name: "",
  props: {
    yearList: {
      type: [Object, Array],
      default: () => {
        [];
      },
    },
    yearLength: {
      type: [Object, Array],
      default: () => {
        [];
      },
    },
    tapDtData: {
      type: [Object],
      default: () => {
        [];
      },
    },
    year: {
      type: [String, Number],
      default: new Date().getFullYear(),
    },
  },
  data() {
    return {
      formData: [],
      resetData: [],
      rules: {
        userName: [{ required: true, message: "必填项", trigger: "change" }],
      },
    };
  },
  created() {
    let yearLength = this.yearLength;
    let yearList = this.yearList;
    let arr = [];
    for (let key in yearLength) {
      let obj = {
        planMonth: yearLength[key],
        planYear: this.year,
        zytz: "",
        sjtz: "",
        dftz: "",
        qt: "",
        projCode: this.$store.state.projectDetail.code,
      };
      arr.push(obj);
      this.resetData.push(obj);
    }
    let arrData = JSON.parse(JSON.stringify(arr));
    for (let key in arrData) {
      yearList.map((item) => {
        if (item.planMonth == arrData[key].planMonth) {
          arrData[key].id = item.id;
          arrData[key].zytz = item.zytz;
          arrData[key].sjtz = item.sjtz;
          arrData[key].dftz = item.dftz;
          arrData[key].qt = item.qt;
        }
      });
    }
    this.formData = arrData;
  },
  methods: {
    reset() {
      this.formData.map((item) => {
        item.zytz = "";
        item.sjtz = "";
        item.dftz = "";
        item.qt = "";
      });
    },
    valChange(val, index, filed) {
      switch (filed) {
        case "zytz":
          if (val.split(".")[1].length > 2) {
            val = val.split(".")[0] + "." + val.split(".")[1].substring(0, 2);
            this.formData[index].zytz = val;
          }
          break;
        case "dftz":
          if (val.split(".")[1].length > 2) {
            val = val.split(".")[0] + "." + val.split(".")[1].substring(0, 2);
            this.formData[index].dftz = val;
          }
          break;
        case "sjtz":
          if (val.split(".")[1].length > 2) {
            val = val.split(".")[0] + "." + val.split(".")[1].substring(0, 2);
            this.formData[index].sjtz = val;
          }
          break;
        case "qt":
          if (val.split(".")[1].length > 2) {
            val = val.split(".")[0] + "." + val.split(".")[1].substring(0, 2);
            this.formData[index].qt = val;
          }
          break;
        default:
          break;
      }
    },
    submitForm() {
      if (this.totalMarks <= this.tapDtData.wfpTz) {
        investPlanApi
          .update({
            json: JSON.stringify(this.formData),
          })
          .then((res) => {
            if (res.success) {
              this.$emit("closeeditdialog");
            } else {
              this.$message("修改失败!" + res.msg);
            }
          });
      } else {
        this.$message("当前年度分配总金额必须小于未分配金额!");
      }
    },
    goBack() {
      this.$emit("closeeditdialog");
    },
  },
  computed: {
    totalMarks: function () {
      let total = 0;
      let me = this;
      for (let i = 0; i < me.formData.length; i++) {
        if (me.formData[i].zytz) {
          total += Number(me.formData[i].zytz);
        }
        if (me.formData[i].sjtz) {
          total += Number(me.formData[i].sjtz);
        }
        if (me.formData[i].dftz) {
          total += Number(me.formData[i].dftz);
        }
        if (me.formData[i].qt) {
          total += Number(me.formData[i].qt);
        }
      }
      return total.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  .total {
    height: 48px;
    line-height: 48px;
    padding-left: 40px;
    background: #eef7ff;
    .item {
      width: 33%;
      float: left;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.48);
      b {
        font-size: 20px;
        color: #18a1ff;
      }
    }
  }
  .info {
    font-size: 18px;
    color: #151515;
    position: relative;
    margin: 24px 0 16px 0;
    display: flex;
    justify-content: space-between;
    &::after {
      content: "";
      position: absolute;
      left: -20px;
      top: 2px;
      width: 4px;
      height: 24px;
      background: #18a1ff;
      border-radius: 2px;
    }
    span {
      font-size: 24px;
      color: #000000;
      b {
        font-size: 28px;
        color: #18a1ff;
      }
    }

    & > div {
      height: 70px;
      display: flex;
      align-items: center;
    }
  }
  .table-box {
    thead {
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #e8e8e8;
    }
    tr {
      border-bottom: 1px solid #e8e8e8;
      td {
        text-align: center;
        padding: 10px;
        line-height: 40px;
      }
    }
  }
  .year-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    height: 480px;
    overflow-y: auto;

    div {
      width: 33.3%;
      box-sizing: border-box;
      text-align: center;
      .tit {
        width: 100%;
        // background: #edf3f9;
        color: #333;
        padding: 15px 0;
        border-right: 1px solid #d6d2cc;
        border-bottom: 1px solid #d6d2cc;
      }
      .tit1,
      .tit2,
      .tit3 {
        border-top: 1px solid #d6d2cc;
      }
      .tit1,
      .tit4,
      .tit7,
      .tit10,
      .content1,
      .content4,
      .content7,
      .content10 {
        border-left: 1px solid #d6d2cc;
      }
      .content {
        width: 100%;
        background: #fff;
        color: #008dfe;
        border-right: 1px solid #d6d2cc;
        border-bottom: 1px solid #d6d2cc;
        .fill {
          width: 100%;
          padding-right: 6px;
          padding-top: 6px;
          div {
            width: 100%;
            margin-bottom: 3px;
            position: relative;
          }
          .el-input {
            width: 84%;
            margin-left: -50px;
          }
          .unit {
            position: absolute;
            right: 0;
            top: 0;
            width: 30px;
            height: 40px;
            float: left;
            color: #606266;
          }
        }
      }
    }
  }
}
.common_table_dialog {
  .el-dialog__body {
    padding: 0 20px 0 20px;
  }
}
</style>

<style>
.table-box .el-form-item {
    margin-bottom: 0px;
}
</style>